import { Card, styled } from "~/common/mui";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { CheckoutProductLine } from "./CheckoutProductLine";

import { CartProductLine } from "./CartProductLine";

import type { HousingProduct } from "~/domains/product/types/ProductData";

import { OptionalPartsEntrySummary } from "./OptionalPartsEntrySummary";

import type { LineItemActions } from "~/domains/cart/hooks/useLineItemActions";
import type { ProductLineViewModel } from "./models/ProductTableViewModel";

interface OptionalPartEntryProps {
  part: HousingProduct;
  descriptor: ProductDescriptor;
  viewModel: ProductLineViewModel;
  actions: LineItemActions | null;
  editMode: boolean;
}

export const OptionalPartEntry = ({
  part: _part,
  descriptor,
  viewModel,
  actions,
  editMode,
}: OptionalPartEntryProps) => {
  if (editMode && actions) {
    return (
      <Card>
        <OptionalPartsEntrySummary product={descriptor} editMode={editMode} />
        <EditableLineItem housingKit={true} line={viewModel} product={descriptor} actions={actions} />
      </Card>
    );
  }

  return (
    <Card>
      <OptionalPartsEntrySummary product={descriptor} editMode={editMode} />
      <ViewableLineItem housingKit={true} line={viewModel} product={descriptor} />
    </Card>
  );
};

const EditableLineItem = styled(CartProductLine)(({ theme }) => ({
  border: "none",
  borderTop: "1px solid",
  borderRadius: 0,
  borderColor: theme.palette.divider,
}));

const ViewableLineItem = styled(CheckoutProductLine)(({ theme }) => ({
  border: "none",
  borderTop: "1px solid",
  borderRadius: 0,
  borderColor: theme.palette.divider,
}));
